import { render, staticRenderFns } from "./FormQuestionRatingType.vue?vue&type=template&id=211d257c"
import script from "./FormQuestionRatingType.vue?vue&type=script&lang=js"
export * from "./FormQuestionRatingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211d257c')) {
      api.createRecord('211d257c', component.options)
    } else {
      api.reload('211d257c', component.options)
    }
    module.hot.accept("./FormQuestionRatingType.vue?vue&type=template&id=211d257c", function () {
      api.rerender('211d257c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionRatingType.vue"
export default component.exports